import FilterIcon from "@lhd/components/FilterIcon";
import { Styles } from "./styled";
import TextToolTip from "@lhd/components/TextToolTip";
import { Column } from "ag-grid-community";

interface HeaderFilterProps {
  displayName: string;
  context: any;
  column: Column;
}

// Columns that should not have filter icon
const COLUMNS_WITHOUT_FILTER = [
  "worker_documents.document_name",
  "worker_company_email.password",
  "worker_base_salary.transition_date",
];

const HeaderFilter = (props: HeaderFilterProps) => {
  const columnId = props.column?.getColId() || "";
  const showFilterIcon = !COLUMNS_WITHOUT_FILTER.includes(columnId);

  return (
    <Styles
      className="d-flex"
      style={{ justifyContent: "space-between", alignItems: "center" }}
    >
      <div
        className="ag-header-cell-text"
        style={{
          maxWidth: "calc(100% - 30px)",
          display: "flex",
          alignItems: "center",
          flexWrap: "nowrap",
        }}
      >
        <TextToolTip style={{ flex: 1, minWidth: 0 }}>
          {props.displayName}
        </TextToolTip>
        {(props.column?.getColDef() as any)?.isRequired && (
          <span style={{ color: "red", marginLeft: "2px", flexShrink: 0 }}>
            *
          </span>
        )}
      </div>
      <div style={{ maxHeight: "22px" }}>
        <FilterIcon
          disabled={props.context.disabledFilter}
          filterInfo={props.context.filterInfo}
          setFilterInfo={props.context.handleSetFilterInfo}
          showFilterIcon={showFilterIcon}
          filter={props.context.filterInfo?.filter || {}}
          columnId={columnId}
        />
      </div>
    </Styles>
  );
};

export default HeaderFilter;
